import { render, staticRenderFns } from "./PopupMedia.vue?vue&type=template&id=48c684de&scoped=true&"
import script from "./PopupMedia.vue?vue&type=script&lang=js&"
export * from "./PopupMedia.vue?vue&type=script&lang=js&"
import style0 from "./PopupMedia.vue?vue&type=style&index=0&id=48c684de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c684de",
  null
  
)

export default component.exports